// framework
import React, { useCallback } from "react";
// constants
import { MESSAGES } from "constants/constants";
// styles
import styles from "./GameOverView.module.scss";
// components
import Button from "components/Shared/Button/Button";

export default function GameOverView({ room }) {
    const onPlayAgain = useCallback(() => {
        room?.send(MESSAGES.TO_SERVER.CALL_END_GAME, {});
    }, [room]);

    const onReturnToLobby = useCallback(() => {
        room?.send(MESSAGES.TO_SERVER.CHANGE_GAME, {});
    }, [room]);

    return (
        <div className={styles.gameOverView}>
            <h1 className={styles.heading}>Game Over</h1>
            <h4 className={styles.sub}>Thanks for playing!</h4>
            <div className={styles.buttons}>
                <Button onClick={onPlayAgain} className={styles.button}>Play Again</Button>
                <Button onClick={onReturnToLobby} className={styles.button}>Return to Lobby</Button>
            </div>
        </div>
    );
}